import { createContext, useContext, useState, useCallback } from "react";

const EnquiryContext = createContext(null);

export const EnquiryProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({});

  const openEnquiry = useCallback((data = {}) => {
    setPrefill(data || {});
    setOpen(true);
  }, []);

  const closeEnquiry = useCallback(() => setOpen(false), []);

  return (
    <EnquiryContext.Provider value={{ open, prefill, openEnquiry, closeEnquiry, setOpen }}>
      {children}
    </EnquiryContext.Provider>
  );
};

export const useEnquiry = () => {
  const ctx = useContext(EnquiryContext);
  if (!ctx) throw new Error("useEnquiry must be used within EnquiryProvider");
  return ctx;
};
